import { createSlice } from '@reduxjs/toolkit';
import { showError } from '@/utils/toast';

const getInitialCartState = () => {
  try {
    const savedCart = localStorage.getItem('cart');
    return savedCart ? JSON.parse(savedCart) : { items: [] };
  } catch (error) {
    console.error("Could not load cart from local storage", error);
    return { items: [] };
  }
};

const saveCartState = (state) => {
  try {
    localStorage.setItem('cart', JSON.stringify(state));
  } catch (error) {
    console.error("Could not save cart to local storage", error);
  }
};

const cartSlice = createSlice({
  name: 'cart',
  initialState: getInitialCartState(),
  reducers: {
    addToCart: (state, action) => {
      const item = action.payload;
      const existing = state.items.find(i => i.productId === item.productId && i.variant === item.variant);
      const stock = item.stock || 0;

      if (existing) {
        if (existing.quantity < stock || item.isPreorder || existing.isPreorder) {
          existing.quantity += item.quantity || 1;
          // Propagate isPreorder flag if this is a pre-order action
          if (item.isPreorder) existing.isPreorder = true;
        } else {
          showError('Cannot add more items than available in stock');
        }
      } else {
        if (stock > 0 || item.isPreorder) {
          state.items.push({ 
            productId: item.productId || item.id,
            quantity: item.quantity || 1,
            price: item.price,
            // Keep UI data for display
            name: item.name,
            image: item.image,
            variant: item.variant,
            stock: item.stock,
            isPreorder: !!item.isPreorder
          });
        } else {
          showError('Cannot add out of stock item to cart');
        }
      }
      saveCartState(state);
    },
    removeFromCart: (state, action) => {
      const productId = action.payload;
      state.items = state.items.filter(i => i.productId !== productId);
      saveCartState(state);
    },
    updateQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      const existing = state.items.find(i => i.productId === id);
      if (existing) {
        if (quantity > 0 && (quantity <= existing.stock || existing.isPreorder)) {
          existing.quantity = quantity;
        } else if (quantity > existing.stock && !existing.isPreorder) {
          showError('Cannot add more items than available in stock');
        }
      }
      saveCartState(state);
    },
    clearCart: (state) => {
      state.items = [];
      saveCartState(state);
    },
  }
});

export const { addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions;
export default cartSlice.reducer;